import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    EXPENSE_ADD_CATEGORY: "api/Expense/AddExpenseCategory",
    EXPENSE_CATEGORY: "api/Expense/Category",
    EXPENSE_CATEGORY_ROLE: "api/Expense/ExpenseCategoryRoleMapping/",
    EXPENSE_CATEGORY_SETTING: "api/Expense/ExpenseCategorySetting",
    EXPENSE_UPDATE_CATEGORY: "api/Expense/UpdateExpenseCategory",
    EXPENSE_DELETE_CATEGORY: "api/Expense/DeleteExpenseCategory",
    EXPENSE_COMPANY_MEMBERS: "api/CompanyMembers",
    EXPENSE_FINANCE_APPROVERS: "api/Expense/DefaultFinanceApprovers",
    EXPENSE_DELETE_FINANCE_APPROVER: "api/Expense/DeleteDefaultFinanceApprovers",
    EXPENSE_DEFAULT_APPROVERS: "api/Expense/DefaultApprovers",
    EXPENSE_UPDATE_FIXED_TRAVEL_CATEGORY: "api/Expense/FixedTravelCategory",
    EXPENSE_APPROVERS: "api/Expense/Approvers",
    EXPENSE_SET_APPROVERS: "api/Expense/v1/SetExpenseUserStatusApprovalMapping",
    EXPENSE_DELETE_APPROVERS: "api/Expense/Approvers",
}

export const addCategory = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPENSE_ADD_CATEGORY, payload);
    return res.data;
}

export const getCategory = async (id: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_CATEGORY}/${id}`);
    return res.data;
}

export const getCategoryRole = async (id: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_CATEGORY_ROLE}/${id}`);
    return res.data;
}

export const getCategorySetting = async (id: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_CATEGORY_SETTING}/${id}`);
    return res.data;
}

export const updateCategory = async (id: any, payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.put<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_UPDATE_CATEGORY}/${id}`, payload);
    return res.data;
}

export const deleteCategory = async (Id: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.delete<ApiResponse<any>>(ENDPOINTS.EXPENSE_DELETE_CATEGORY, { params: { Id } });
    return res.data;
}

export const getCompanyMembers = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPENSE_COMPANY_MEMBERS, { params: payload });
    return res.data;
}

export const setDefaultFinanceApprovers = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPENSE_FINANCE_APPROVERS, payload);
    return res.data;
}

export const getDefaultFinanceApprovers = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPENSE_FINANCE_APPROVERS);
    return res.data;
}

export const deleteFinanceApprover = async (approverId: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_DELETE_FINANCE_APPROVER}?approverId=${approverId}`);
    return res.data;
}

export const getDefaultApprovers = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPENSE_DEFAULT_APPROVERS);
    return res.data;
}

export const updateFixedTravelCategory = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.put<ApiResponse<any>>(ENDPOINTS.EXPENSE_UPDATE_FIXED_TRAVEL_CATEGORY, payload);
    return res.data;
}

export const addDefaultApprover = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPENSE_DEFAULT_APPROVERS, payload);
    return res.data;
}

export const deleteDefaultApprover = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.delete<ApiResponse<any>>(ENDPOINTS.EXPENSE_DEFAULT_APPROVERS, { params: payload });
    return res.data;
}

export const getApprovers = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPENSE_APPROVERS, { params: payload });
    return res.data;
}

export const setExpenseApprover = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPENSE_SET_APPROVERS, payload);
    return res.data;
}

export const deleteApprover = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.delete<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_DELETE_APPROVERS}`, { params: payload });
    return res.data;
}

const expenseSetting = {
    addCategory,
    getCategory,
    getCategoryRole,
    getCategorySetting,
    updateCategory,
    deleteCategory,
    getCompanyMembers,
    setDefaultFinanceApprovers,
    getDefaultFinanceApprovers,
    deleteFinanceApprover,
    getDefaultApprovers,
    updateFixedTravelCategory,
    addDefaultApprover,
    deleteDefaultApprover,
    getApprovers,
    setExpenseApprover,
    deleteApprover,
}

export default expenseSetting;